import RsaGestionePazientiAdiListPage from "./pages/RsaGestionePazientiAdiListPage.vue";

export default {
	RsaGestionePazientiAdiListPage,
};
